import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  dynamicLabels = signal<Record<string, string>>({});

  setLabel(routeSegment: string, label: string) {
    this.dynamicLabels.update(labels => ({
      ...labels,
      [routeSegment]: label
    }));
  }

  getLabel(routeSegment: string): string | undefined {
    return this.dynamicLabels()[routeSegment];
  }

  clearLabel(routeSegment: string) {
    this.dynamicLabels.update(labels => {
      const newLabels = { ...labels };
      delete newLabels[routeSegment];
      return newLabels;
    });
  }
}
